import { useRef } from "react";
import { gsap, isCoarsePointer, prefersReducedMotion } from "@/lib/motion";

/**
 * Pulls a control gently toward the cursor. Touch and reduced-motion users get
 * the plain child, so the button never ends up displaced with no way to reset it.
 */
export default function Magnetic({ children, strength = 0.12, className = "" }) {
  const ref = useRef(null);
  const enabled = !isCoarsePointer() && !prefersReducedMotion();

  const onMove = (e) => {
    if (!enabled || !ref.current) return;
    const r = ref.current.getBoundingClientRect();
    gsap.to(ref.current, {
      x: (e.clientX - (r.left + r.width / 2)) * strength,
      y: (e.clientY - (r.top + r.height / 2)) * strength,
      duration: 0.4,
      ease: "power3.out",
    });
  };

  const onLeave = () => {
    if (!enabled || !ref.current) return;
    /* Sobered: settles back, no elastic wobble. The button should feel weighted,
       not springy. */
    gsap.to(ref.current, { x: 0, y: 0, duration: 0.35, ease: "power3.out" });
  };

  return (
    <div
      ref={ref}
      className={`inline-flex ${className}`}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
    >
      {children}
    </div>
  );
}
